import React, {
  useEffect,
  useState,
  Fragment,
  useCallback,
  useContext,
} from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import CheckboxFir from "components/sales/Input/checkbox/checkboxFir";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import DatePicker from "components/sales/datePicker/datePicker";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from "assets/images/imageData";
import { toast } from "react-toastify";
import "./corpui.css";

const CorporateMallForm = ({
  match,
  history,
  corporateAutofillData,
  corporateAutofill,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const [allchecked, setAllChecked] = useState([]);
  const { baseUrl } = useContext(BaseUrl);

  const [inputList, setInputList] = useState([
    {
      date: "",
      project_name: "",
      city_name: "",
      meeting_person_name: "",
      number_of_participants: "",
      number_of_4w: "",
      total_tenants: "",
      number_of_2w: "",
      total_tags_ordered: "",
      signages: "",
      signage_information: "",
      hand_held_tags: "",
      access_Management_RFID_4W: "",
      access_Management_RFID_2W: "",
      access_inventory_mgmt_4W: "",
      access_inventory_mgmt_2W: "",
      access_inventory_mgmt_visitors: "",
      fastag_integration: "",
      fastag_access_charging: "",
      subgating_flow: "",
      park_RFID_tags_4W: "",
      park_RFID_tags_2W: "",
      parkHandheld_tags_2W: "",
      park_tags: "",
      fastags: "",
      anpr_access: "",
      anpr_logging: "",
      camera: "",
      camera_integration: "",
      tvm_integration: "",
      new_tvm: "",
      pgs_basic: "",
      pgs_upgrade: "",
      pgs_fullversion: "",
      led_displayboard: "",
      single_rowLed: "",
      two_rowLed: "",
      tv_screen: "",
      outdoor_screens: "",
      pos_with_pms: "",
      pos_charging: "",
      pos_charging_card_payment: "",
      pos_with_controller: "",
      pos_sim_based: "",
      slot_availability: "",
      other_requirement: "",
      project_boq_annexue: "",
      layout_discussed: "",
      brd_discussed: "",
      flowchart_usecase: "",
      print_slipformat: "",
      focreasons_required: "",
      tenantslots_parking: "",
      tag_onboarding_process: "",
      tentative_live_date: "",
      internet_availability_date: "",
      ip_whitelisting: "",
      ip_whitelisting_remark: "",
      open_portsavi: "",
      open_portsavi_remark: "",
      dashboard_training: "",
      how_to_raise_complaints: "",
      payment_briefing: "",
      carnival_overview: "",
      troubleshooting_faq: "",
      how_to_activate_tags: "",
      feedback: "",
      work_permit_all_days: "",
      work_permit_all_days_remark: "",
      additional_permit: "",
      storage_available: "",
      permit_required: "",
      work_permission: "",
      delivery_challan: "",
      handover_sign: "",
      delivery_challan_power: "",
      warranty_certificates: "",
      work_completion_certificate: "",
      training_certificate: "",
      specific_document: "",
      payment_collection_method: "",
      mdr_value_finalized: "",
      mdr_value_remark: "",
      agreement_signed_between: "",
      first_reminder_communication: "",
      two_reminder_communication: "",
      three_reminder_communication: "",
      four_reminder_communication: "",
      tenant_slots_data: "",
      tenant_login: "",
      qr_placement: "",
      tenant_admins: "",
      standee_deployment: "",
      tag_activation: "",
      park_partner: "",
      park_partner_reason: "",
      daily_car_cleaning: "",
      daily_car_cleaning_reason: "",
      car_display: "",
      car_display_reason: "",
      carnival_date_time: "",
      identified_area_location: "",
      flag_installation: "",
      aligning_building: "",
      push_message: "",
      client_name: "",
      designation: "",
      email_address: "",
      phone_number: "",
      new_feedback: "",
      rm_name: "",
      other_client_name: "",
      client_rental_self_deposit: "",
      client_rental_online_mode: "",
      late_payment_fees_check: "",
      auto_shuts_off_check: "",

      // type: "",
      // any_other_requirement: "",
      // self_assigned: false,
      // internet_availability_date: "",
      // body: "",
      // reason_for_not_opting: "",
      // car_health_checkup: "",
      // fastag_helpdesk: "",
      // parkplus_go: "",
      // parkplus_retail_products: "",
      // confirmation_park: "",
    },
  ]);

  const [formData, setFormData] = useState(inputList);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   console.log(formData);
  //   const payload = {
  //     firData: formData,
  //     fir_type: 2,
  //     site_id: match?.params?.id,
  //   };
  //   const url = `${Config.installation.firFormSubmit}`;
  //   const { data } = await axios.post(url, payload);
  //   return false;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);
    const payload = {
      firData: formData,
      fir_type: 2,
      site_id: match?.params?.id,
    };

    setIsLoading(true);
    const url = `${Config.installation.firFormSubmit}`;
      const { data } = await axios.post(url, payload);
      if(data){
        setIsModal(true);
      }
      else{
        setIsModal(false);
      }

      setIsLoading(false);
  };

  const handleInput2Value = (val, key) => {
    const list = [...formData];
    list[0][key] = val;
    setFormData(list);
  };

  const handleModalHide = () => {
     setIsModal(false);
     history.push(`${baseUrl}/gate/fir-integration/${match?.params?.id}/stage/7`);
  };


  const handleSaveDraft = async (val) => {
    const payload = {
      firData: formData,
      fir_type: 1,
      site_id: match?.params?.id,
    };
    try {
      const url = Config.installation.saveasDraft;
      const response = await axios.post(url, payload);
      console.log("Saved as Draft:", val);
    } catch (error) {
      console.error("Error saving as draft:", error);
    }
  };

  useEffect(() => {
    if (corporateAutofillData !== null && match.params.id)
      (async () => {
        setIsLoading(true);
        await corporateAutofillData(match.params.id);
        setIsLoading(false);
      })();
  }, [corporateAutofillData, match.params.id]);

  useEffect(() => {
    if (corporateAutofill) {
      // console.log(corporateAutofill);
      setIsLoading(true);
      inputList[0]["date"] = corporateAutofill?.date || "";
      inputList[0]["project_name"] = corporateAutofill?.project_name || "";
      inputList[0]["city_name"] = corporateAutofill?.city_name || "";
      inputList[0]["meeting_person_name"] =
        corporateAutofill?.meeting_person_name || "";
      inputList[0]["number_of_participants"] =
        corporateAutofill?.number_of_participants || "";
      inputList[0]["number_of_4w"] = corporateAutofill?.number_of_4w || "";
      inputList[0]["total_tenants"] = corporateAutofill?.total_tenants || "";
      inputList[0]["number_of_2w"] = corporateAutofill?.number_of_2w || "";
      inputList[0]["total_tags_ordered"] =
        corporateAutofill?.total_tags_ordered || "";
      inputList[0]["signages"] = corporateAutofill?.signages || "";
      inputList[0]["signage_information"] =
        corporateAutofill?.signage_information || "";
      inputList[0]["hand_held_tags"] = corporateAutofill?.hand_held_tags || "";
      inputList[0]["access_Management_RFID_4W"] =
        corporateAutofill?.access_Management_RFID_4W || "";
      inputList[0]["access_Management_RFID_2W"] =
        corporateAutofill?.access_Management_RFID_2W || "";
      inputList[0]["access_inventory_mgmt_4W"] =
        corporateAutofill?.access_inventory_mgmt_4W || "";
      inputList[0]["access_inventory_mgmt_2W"] =
        corporateAutofill?.access_inventory_mgmt_2W || "";
      inputList[0]["access_inventory_mgmt_visitors"] =
        corporateAutofill?.access_inventory_mgmt_visitors || "";
      inputList[0]["fastag_integration"] =
        corporateAutofill?.fastag_integration || "";
      inputList[0]["fastag_access_charging"] =
        corporateAutofill?.fastag_access_charging || "";
      inputList[0]["subgating_flow"] = corporateAutofill?.subgating_flow || "";
      inputList[0]["park_RFID_tags_4W"] =
        corporateAutofill?.park_RFID_tags_4W || "";
      inputList[0]["park_RFID_tags_2W"] =
        corporateAutofill?.park_RFID_tags_2W || "";
      inputList[0]["parkHandheld_tags_2W"] =
        corporateAutofill?.parkHandheld_tags_2W || "";
      inputList[0]["park_tags"] = corporateAutofill?.park_tags || "";
      inputList[0]["fastags"] = corporateAutofill?.fastags || "";
      inputList[0]["anpr_access"] = corporateAutofill?.anpr_access || "";
      inputList[0]["anpr_logging"] = corporateAutofill?.anpr_logging || "";
      inputList[0]["camera"] = corporateAutofill?.camera || "";
      inputList[0]["camera_integration"] =
        corporateAutofill?.camera_integration || "";
      inputList[0]["tvm_integration"] =
        corporateAutofill?.tvm_integration || "";
      inputList[0]["new_tvm"] = corporateAutofill?.new_tvm || "";
      inputList[0]["pgs_basic"] = corporateAutofill?.pgs_basic || "";
      inputList[0]["pgs_upgrade"] = corporateAutofill?.pgs_upgrade || "";
      inputList[0]["pgs_fullversion"] =
        corporateAutofill?.pgs_fullversion || "";
      inputList[0]["led_displayboard"] =
        corporateAutofill?.led_displayboard || "";
      inputList[0]["single_rowLed"] = corporateAutofill?.single_rowLed || "";
      inputList[0]["two_rowLed"] = corporateAutofill?.two_rowLed || "";
      inputList[0]["tv_screen"] = corporateAutofill?.tv_screen || "";
      inputList[0]["outdoor_screens"] =
        corporateAutofill?.outdoor_screens || "";
      inputList[0]["pos_with_pms"] = corporateAutofill?.pos_with_pms || "";
      inputList[0]["pos_charging"] = corporateAutofill?.pos_charging || "";
      inputList[0]["pos_charging_card_payment"] =
        corporateAutofill?.pos_charging_card_payment || "";
      inputList[0]["pos_with_controller"] =
        corporateAutofill?.pos_with_controller || "";
      inputList[0]["pos_sim_based"] = corporateAutofill?.pos_sim_based || "";
      inputList[0]["slot_availability"] =
        corporateAutofill?.slot_availability || "";
      inputList[0]["other_requirement"] =
        corporateAutofill?.other_requirement || "";
      inputList[0]["project_boq_annexue"] =
        corporateAutofill?.project_boq_annexue || "";
      inputList[0]["layout_discussed"] =
        corporateAutofill?.layout_discussed || "";
      inputList[0]["brd_discussed"] = corporateAutofill?.brd_discussed || "";
      inputList[0]["flowchart_usecase"] =
        corporateAutofill?.flowchart_usecase || "";
      inputList[0]["print_slipformat"] =
        corporateAutofill?.print_slipformat || "";
      inputList[0]["focreasons_required"] =
        corporateAutofill?.focreasons_required || "";
      inputList[0]["tenantslots_parking"] =
        corporateAutofill?.tenantslots_parking || "";
      inputList[0]["tag_onboarding_process"] =
        corporateAutofill?.tag_onboarding_process || "";
      inputList[0]["tentative_live_date"] =
        corporateAutofill?.tentative_live_date || "";
      inputList[0]["ip_whitelisting"] =
        corporateAutofill?.ip_whitelisting || "";
      inputList[0]["ip_whitelisting_remark"] =
        corporateAutofill?.ip_whitelisting_remark || "";
      inputList[0]["open_portsavi"] = corporateAutofill?.open_portsavi || "";
      inputList[0]["open_portsavi_remark"] =
        corporateAutofill?.open_portsavi_remark || "";
      inputList[0]["dashboard_training"] =
        corporateAutofill?.dashboard_training || "";
      inputList[0]["how_to_raise_complaints"] =
        corporateAutofill?.how_to_raise_complaints || "";
      inputList[0]["payment_briefing"] =
        corporateAutofill?.payment_briefing || "";
      inputList[0]["carnival_overview"] =
        corporateAutofill?.carnival_overview || "";
      inputList[0]["troubleshooting_faq"] =
        corporateAutofill?.troubleshooting_faq || "";
      inputList[0]["how_to_activate_tags"] =
        corporateAutofill?.how_to_activate_tags || "";
      inputList[0]["feedback"] = corporateAutofill?.feedback || "";
      inputList[0]["work_permit_all_days"] =
        corporateAutofill?.work_permit_all_days || "";
      inputList[0]["work_permit_all_days_remark"] =
        corporateAutofill?.work_permit_all_days_remark || "";
      inputList[0]["additional_permit"] =
        corporateAutofill?.additional_permit || "";
      inputList[0]["storage_available"] =
        corporateAutofill?.storage_available || "";
      inputList[0]["permit_required"] =
        corporateAutofill?.permit_required || "";
      inputList[0]["work_permission"] =
        corporateAutofill?.work_permission || "";
      inputList[0]["delivery_challan"] =
        corporateAutofill?.delivery_challan || "";
      inputList[0]["handover_sign"] = corporateAutofill?.handover_sign || "";
      inputList[0]["delivery_challan_power"] =
        corporateAutofill?.delivery_challan_power || "";
      inputList[0]["warranty_certificates"] =
        corporateAutofill?.warranty_certificates || "";
      inputList[0]["work_completion_certificate"] =
        corporateAutofill?.work_completion_certificate || "";
      inputList[0]["training_certificate"] =
        corporateAutofill?.training_certificate || "";
      inputList[0]["specific_document"] =
        corporateAutofill?.specific_document || "";
      inputList[0]["payment_collection_method"] =
        corporateAutofill?.payment_collection_method || "";
      inputList[0]["mdr_value_finalized"] =
        corporateAutofill?.mdr_value_finalized || "";
      inputList[0]["mdr_value_remark"] =
        corporateAutofill?.mdr_value_remark || "";
      inputList[0]["agreement_signed_between"] =
        corporateAutofill?.agreement_signed_between || "";
      inputList[0]["first_reminder_communication"] =
        corporateAutofill?.first_reminder_communication || "";
      inputList[0]["two_reminder_communication"] =
        corporateAutofill?.two_reminder_communication || "";
      inputList[0]["three_reminder_communication"] =
        corporateAutofill?.three_reminder_communication || "";
      inputList[0]["four_reminder_communication"] =
        corporateAutofill?.four_reminder_communication || "";
      inputList[0]["tenant_slots_data"] =
        corporateAutofill?.tenant_slots_data || "";
      inputList[0]["tenant_login"] = corporateAutofill?.tenant_login || "";
      inputList[0]["qr_placement"] = corporateAutofill?.qr_placement || "";
      inputList[0]["tenant_admins"] = corporateAutofill?.tenant_admins || "";
      inputList[0]["standee_deployment"] =
        corporateAutofill?.standee_deployment || "";
      inputList[0]["tag_activation"] = corporateAutofill?.tag_activation || "";
      inputList[0]["park_partner"] = corporateAutofill?.park_partner || "";
      inputList[0]["park_partner_reason"] =
        corporateAutofill?.park_partner_reason || "";
      inputList[0]["daily_car_cleaning"] =
        corporateAutofill?.daily_car_cleaning || "";
      inputList[0]["daily_car_cleaning_reason"] =
        corporateAutofill?.daily_car_cleaning_reason || "";
      inputList[0]["car_display"] = corporateAutofill?.car_display || "";
      inputList[0]["car_display_reason"] =
        corporateAutofill?.car_display_reason || "";
      inputList[0]["carnival_date_time"] =
        corporateAutofill?.carnival_date_time || "";
      inputList[0]["identified_area_location"] =
        corporateAutofill?.identified_area_location || "";
      inputList[0]["flag_installation"] =
        corporateAutofill?.flag_installation || "";
      inputList[0]["aligning_building"] =
        corporateAutofill?.aligning_building || "";
      inputList[0]["push_message"] = corporateAutofill?.push_message || "";
      inputList[0]["client_name"] = corporateAutofill?.client_name || "";
      inputList[0]["designation"] = corporateAutofill?.designation || "";
      inputList[0]["email_address"] = corporateAutofill?.email_address || "";
      inputList[0]["phone_number"] = corporateAutofill?.phone_number || "";
      inputList[0]["new_feedback"] = corporateAutofill?.new_feedback || "";
      inputList[0]["rm_name"] = corporateAutofill?.rm_name || "";
      inputList[0]["other_client_name"] =
        corporateAutofill?.other_client_name || "";
      inputList[0]["client_rental_self_deposit"] = corporateAutofill?.client_rental_self_deposit || "";
      inputList[0]["client_rental_online_mode"] = corporateAutofill?.client_rental_online_mode || "";
      inputList[0]["late_payment_fees_check"] = corporateAutofill?.late_payment_fees_check || "";
      inputList[0]["auto_shuts_off_check"] = corporateAutofill?.auto_shuts_off_check || "";

      setInputList(inputList);
      setIsLoading(false);
    }
  }, [corporateAutofill]);
  
  return (
    <Layout
      title={localization.firstInteractionForm}
      isLoading={isLoading}
      isGoback={true}
    >
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.firSuccess}</h5>
          {/* <Link
            to={
              match?.params?.type !== undefined
                ? `${baseUrl}/brand-activation/viewPoc/${match?.params?.type}/${siteId}`
                : `${baseUrl}/brand-activation/viewPoc/${siteId}`
            }
            className="btn btn-primary mb-4"
          >
            {localization.pocList} <img src={Images?.ArrowRight} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      
      <form onSubmit={handleSubmit}>
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">{localization.corporateMall}</div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.date}
                    errorMsg={localization.requiredProjectName}
                    type="text"
                    required
                    isStarRequired={true}
                    disabled={true}
                    value={corporateAutofill?.date}
                    handleChange={(val) => {
                      handleInput2Value(val, "date");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.projectName}
                    errorMsg={localization.requiredProjectName}
                    type="text"
                    value={corporateAutofill?.project_name}
                    variant="standard"
                    required
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "project_name");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.city}
                    value={corporateAutofill?.city_name}
                    errorMsg={localization.requiredCityName}
                    type="text"
                    required
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "city_name");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.meetingPersonName}
                    errorMsg={localization.requiredMeetingPersonName}
                    type="text"
                    required
                    value={corporateAutofill?.meeting_person_name}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "meeting_person_name");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.noOfParticipants}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={corporateAutofill?.number_of_participants}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "number_of_participants");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.noOf4W}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={corporateAutofill?.number_of_4w}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "number_of_4w");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.totalTenants}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={corporateAutofill?.total_tenants}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "total_tenants");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.noOf2W}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.number_of_2w}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "number_of_2w");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.totalTagsOrdered}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={corporateAutofill?.total_tags_ordered}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "total_tags_ordered");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.signages}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.signages}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "signages");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.infoOnSignageInstallation}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.signage_information}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "signage_information");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.handHeldTags}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.hand_held_tags}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "hand_held_tags");
                    }}
                  />
                </div>
              </div>

              <div>
                <h5>
                  <b>Flow functionality applicable at site(Yes-No):</b>
                </h5>
                <br></br>
                <p>
                  <u>TYPES OF FLOWS-</u>
                </p>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.accessManagementRFID4W}
                    required
                    value={corporateAutofill?.access_Management_RFID_4W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "access_Management_RFID_4W");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.accessManagementRFID2W}
                    required
                    value={corporateAutofill?.access_Management_RFID_2W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "access_Management_RFID_2W");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.accessInventoryMgmt4W}
                    required
                    value={corporateAutofill?.access_inventory_mgmt_4W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "access_inventory_mgmt_4W");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.accessInventoryMgmt2W}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.access_inventory_mgmt_2W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "access_inventory_mgmt_2W");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.accessInventoryMgmtVisitors}
                    required
                    errorMsg={localization.requiredName}
                    value={corporateAutofill?.access_inventory_mgmt_visitors}
                    getIdValue={(val) => {
                      handleInput2Value(
                        val.id,
                        "access_inventory_mgmt_visitors"
                      );
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "Yes", name: "No" },
                    ]}
                    label={localization.fastagIntegration}
                    required
                    value={corporateAutofill?.fastag_integration}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "fastag_integration");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.fastagAccessCharging}
                    required
                    value={corporateAutofill?.fastag_access_charging}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "fastag_access_charging");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.subgatingFlow}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.subgating_flow}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "subgating_flow");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div>
                <br></br>
                <p>
                  <u>TYPES OF TAGS</u>
                </p>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.parkRFIDTags4W}
                    required
                    value={corporateAutofill?.park_RFID_tags_4W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "park_RFID_tags_4W");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.parkRFIDTags2W}
                    required
                    value={corporateAutofill?.park_RFID_tags_2W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "park_RFID_tags_2W");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.parkHandheldTags2W}
                    required
                    value={corporateAutofill?.parkHandheld_tags_2W}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "parkHandheld_tags_2W");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.parkTags}
                    required
                    value={corporateAutofill?.park_tags}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "park_tags");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.fastags}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.fastags}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "fastags");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div>
                <br></br>
                <p>
                  <u>TYPES OF PREMIUM SOLUTIONS</u>
                </p>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.anprAccess}
                    required
                    value={corporateAutofill?.anpr_access}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "anpr_access");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.anprLogging}
                    required
                    value={corporateAutofill?.anpr_logging}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "anpr_logging");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.camera}
                    required
                    value={corporateAutofill?.camera}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "camera");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.cameraIntegration}
                    required
                    value={corporateAutofill?.camera_integration}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "camera_integration");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.tvmIntegration}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.tvm_integration}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tvm_integration");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.newTvm}
                    required
                    value={corporateAutofill?.new_tvm}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "new_tvm");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.pgsBasic}
                    required
                    value={corporateAutofill?.pgs_basic}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pgs_basic");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.pgsUpgrade}
                    required
                    value={corporateAutofill?.pgs_upgrade}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pgs_upgrade");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.pgsFullversion}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.pgs_fullversion}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pgs_fullversion");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div>
                <b>
                  <p>TYPE OF DISPLAYS-</p>
                </b>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.ledDisplayBoard}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.led_displayboard}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "led_displayboard");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.singleRowLed}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.single_rowLed}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "single_rowLed");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.twoRowLed}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.two_rowLed}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "two_rowLed");
                    }}
                  />
                </div>

                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.tvScreen}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.tv_screen}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "tv_screen");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.outdoorScreens}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.outdoor_screens}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "outdoor_screens");
                    }}
                  />
                </div>
              </div>

              <div>
                <b>
                  <p>TYPE OF POS-</p>
                </b>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.posWithPms}
                    required
                    value={corporateAutofill?.pos_with_pms}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pos_with_pms");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.posCharging}
                    required
                    value={corporateAutofill?.pos_charging}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pos_charging");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.posChargingCardPayment}
                    required
                    value={corporateAutofill?.pos_charging_card_payment}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pos_charging_card_payment");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.posWithController}
                    required
                    value={corporateAutofill?.pos_with_controller}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pos_with_controller");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.posSimBased}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.pos_sim_based}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "pos_sim_based");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div>
                <b>
                  <p>SLOT AVAILABILITY-</p>
                </b>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.slotAvailability}
                    required
                    value={corporateAutofill?.slot_availability}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "slot_availability");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.anyOtherRequirements}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.other_requirement}
                    isStarRequired={true}
                    getIdValue={(val) => {
                      handleInput2Value(val, "other_requirement");
                    }}
                  />
                </div>
              </div>

              <div>
                <h5>
                  <b>Project Checklist-</b>
                </h5>
                <br></br>
                <div className="row">
                  <div className="col-6">
                    <CheckboxFir
                      label={localization.projectBoqAnnexue}
                      type="checkbox"
                      value={inputList[0]?.project_boq_annexue}
                      isChecked={inputList[0]?.project_boq_annexue}
                      errorMsg={localization.isRequired}
                      required
                      onChange={(val) => {
                        handleInput2Value(val, "project_boq_annexue");
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <CheckboxFir
                      label={localization.layoutDiscussed}
                      type="checkbox"
                      isChecked={inputList[0].layout_discussed}
                      errorMsg={localization.isRequired}
                      required
                      onChange={(val) => {
                        handleInput2Value(val, "layout_discussed");
                      }}
                    />
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-6">
                    <CheckboxFir
                      label={localization.brdDiscussed}
                      type="checkbox"
                      isChecked={inputList[0]?.brd_discussed}
                      value={inputList[0]?.brd_discussed}
                      errorMsg={localization.isRequired}
                      required
                      onChange={(val) => {
                        handleInput2Value(val, "brd_discussed");
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <CheckboxFir
                      label={localization.flowchartUsecase}
                      type="checkbox"
                      isChecked={inputList[0]?.flowchart_usecase}
                      value={inputList[0]?.flowchart_usecase}
                      errorMsg={localization.isRequired}
                      required
                      onChange={(val) => {
                        handleInput2Value(val, "flowchart_usecase");
                      }}
                    />
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-6">
                    <CheckboxFir
                      label={localization.printSlipFormat}
                      type="checkbox"
                      isChecked={inputList[0].print_slipformat}
                      errorMsg={localization.isRequired}
                      required
                      onChange={(val) => {
                        handleInput2Value(val, "print_slipformat");
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <CheckboxFir
                      label={localization.tenantSlotsParking}
                      type="checkbox"
                      isChecked={inputList[0].tenantslots_parking}
                      errorMsg={localization.isRequired}
                      required
                      onChange={(val) => {
                        handleInput2Value(val, "tenantslots_parking");
                      }}
                      corpClass={"corpCheckBox"}
                    />
                  </div>
                </div>
                <br></br>
              </div>
              <br></br>
              <br></br>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Briefed", name: "Briefed" },
                      { id: "PPT Shared", name: "PPT Shared" },
                      { id: "To be discussed", name: "To be discussed" },
                    ]}
                    label={localization.tagOnboardingProcess}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.tag_onboarding_process}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tag_onboarding_process");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DatePicker
                    label={localization.tentativeLiveDate}
                    required={false}
                    value={corporateAutofill?.tentative_live_date}
                    handleChange={(val) => {
                      handleInput2Value(val, "tentative_live_date");
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DatePicker
                    label={localization.internetAvailabiltyDate}
                    required={false}
                    value={corporateAutofill?.internet_availability_date}
                    handleChange={(val) => {
                      handleInput2Value(val, "internet_availability_date");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.ipWhitelisting}
                    required
                    value={corporateAutofill?.ip_whitelisting}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "ip_whitelisting");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.ip_whitelisting === "Yes" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.ipWhitelisitngRemark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.ip_whitelisting_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "ip_whitelisting_remark");
                      }}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.openPortsAvi}
                    required
                    value={corporateAutofill?.open_portsavi}
                    onFocus={(val) => handleSaveDraft(val)}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "open_portsavi");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.open_portsavi === "Yes" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.openportAvlRemark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.open_portsavi_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "open_portsavi_remark");
                      }}
                    />
                  </div>
                )}
              </div>

              <div>
                <b>
                  <p>Training Needs for corporate (Yes/No)</p>
                </b>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.dashboardTraining}
                    required
                    value={corporateAutofill?.dashboard_training}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "dashboard_training");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.howToRaiseComplaints}
                    required
                    value={corporateAutofill?.how_to_raise_complaints}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "how_to_raise_complaints");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.paymentBriefing}
                    required
                    value={corporateAutofill?.payment_briefing}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "payment_briefing");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.carnivalOverview}
                    required
                    value={corporateAutofill?.carnival_overview}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "carnival_overview");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.troubleshootingFAQ}
                    required
                    value={corporateAutofill?.troubleshooting_faq}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "troubleshooting_faq");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.howToActivateTags}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.how_to_activate_tags}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "how_to_activate_tags");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <b>
                    <p>
                      Training Feedback (Please share your feedback and further
                      training requirement details)
                    </p>
                  </b>

                  <div className="col md-6">
                    <TextAreaInput
                      type="text"
                      label={localization.feedBack}
                      rows={4}
                      value={formData[0]?.feedback}
                      className={` inline-css scrollbar-styling`}
                      inputValue={formData[0]?.feedback}
                      errorMsg={localization.isRequired}
                      handleChange={(val) => {
                        handleInput2Value(val.target.value, "feedback");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <h5>
                  <b>Work Permissions-</b>
                </h5>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.workPermitAllDays}
                    required
                    value={corporateAutofill?.work_permit_all_days}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      // console.log(val?.id)
                      handleInput2Value(val.id, "work_permit_all_days");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.work_permit_all_days === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.workPermitRemark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.work_permit_all_days_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "work_permit_all_days_remark");
                      }}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.additionalPermitRequired}
                    required
                    value={corporateAutofill?.additional_permit}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "additional_permit");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.storageAvailable}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.storage_available}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "storage_available");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.permitRequired}
                    required
                    value={corporateAutofill?.permit_required}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "permit_required");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.specificWorkPermission}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.work_permission}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "work_permission");
                    }}
                  />
                </div>
              </div>

              <div>
                <b>
                  <p>Documents required for invoicing/billing (Yes/No)</p>
                </b>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.deliverychallanHardware}
                    required
                    value={corporateAutofill?.delivery_challan}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "delivery_challan");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.deliverychallanPower}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.delivery_challan_power}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "delivery_challan_power");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.handoversignDocument}
                    required
                    value={corporateAutofill?.handover_sign}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "handover_sign");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.warrantyCertificates}
                    required
                    value={corporateAutofill?.warranty_certificates}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "warranty_certificates");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.workcompletionCertificate}
                    required
                    value={corporateAutofill?.work_completion_certificate}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "work_completion_certificate");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.trainingCertificate}
                    required
                    value={corporateAutofill?.training_certificate}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "training_certificate");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.specificDocument}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.specific_document}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "specific_document");
                    }}
                  />
                </div>
              </div>

              <div>
                <h5>
                  <b>
                    <p>Payment Collection Method</p>
                  </b>
                </h5>
              </div>
              <div>
                <br></br>
                <b>
                  <p style={{ color: "red" }}>
                    If Cheque than cheque collection charges of 500 + GST.
                  </p>
                </b>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Cheque", name: "Cheque" },
                      { id: "Online", name: "Online" },
                    ]}
                    label={localization.paymentcollectionmethod}
                    required
                    value={corporateAutofill?.payment_collection_method}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "payment_collection_method");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div>
                <h5>
                  <b>
                    <p>Fastag/UPI Payment Remittance Process</p>
                  </b>
                </h5>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.mdrValuefinalized}
                    required
                    value={corporateAutofill?.mdr_value_finalized}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "mdr_value_finalized");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.mdr_value_finalized === "Yes" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.mdrvalueRemark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.mdr_value_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "mdr_value_remark");
                      }}
                    />
                  </div>
                )}

                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.agreementSignedBetween}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.agreement_signed_between}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "agreement_signed_between");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div>
                <p>The Finance TAT for remittance of payment is briefed.</p>
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <th>Payment Mode</th>
                      <th>Remittance TAT</th>
                    </tr>
                    <tr>
                      <td>UPI/Card/Netbanking</td>
                      <td>T+2 days</td>
                    </tr>
                    <tr>
                      <td>Fastag</td>
                      <td>T+3 days</td>
                    </tr>
                  </tbody>
                </table>
                <p>Note- T= Day of transaction</p>
                <p>
                  The Format on which payment remittance will be shared is
                  briefed?
                </p>
              </div>
              <div>
                <b>
                  <p>Fastag-</p>
                </b>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Transaction Date</th>
                      <th>Settlement Amount(A)</th>
                      <th>MDR @2.2%(B)</th>
                      <th>GST @18%(C)</th>
                      <th>Remittance Amount (A-B-C)</th>
                      <th>Remittance UTR No.</th>
                      <th>Remittance Date.</th>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div>
                <b>
                  <p>UPI/Card/Netbanking-</p>
                </b>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Transaction Date</th>
                      <th>Settlement Amount(A)</th>
                      <th>MDR @2.2%(B)</th>
                      <th>GST @18%(C)</th>
                      <th>Remittance Amount (A-B-C)</th>
                      <th>Remittance UTR No.</th>
                      <th>Remittance Date.</th>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  The account details of the client have been asked to be shared
                  on email for initiating remittance ?
                </p>
                <p>Account Holder Name-</p>
                <p>Account Number-</p>
                <p>Bank Name-</p>
                <p>IFSC Code-</p>
              </div>

              <div>
                <h5>
                  <b>
                    <p>User Onboarding Process</p>
                  </b>
                </h5>
                <b>
                  <center>Purpose</center>
                </b>
                <p>
                  The Purpose of User onboarding is to give seamless experience
                  of access management to the users with PARK+ system. During
                  project execution, PARK+ Relationship manager (RM) will
                  contact the user (Building Admin) and explain the process of
                  User Onboarding flow. The RM is the Single point of contact
                  for Customer for User Onboarding and he/she will provide
                  training to the building admin on our Mobile Application and
                  Client / tenant dashboard.
                </p>
                <p>
                  At any site there are two categories of parking users as
                  determined by the respective project admins :
                </p>
                <p>
                  1. Whitelisted Users - Who shall be provided free parking
                  facility. for ex. - employees Staff, retail shop owners etc.
                </p>
                <p>
                  2. Paid Users - Who shall be charged parking fee for parking
                  facility. for ex. Visitors, cabs etc.{" "}
                </p>
                <p>
                  Users who shall be provided free parking, either they need to
                  activate the Park+ RFID tag or if the client has opted for
                  Fastag solution then their Fastags need to be whitelisted in
                  our system so that whenever they enter the premises, our
                  system will grant them access and will not charge for parking.
                  In order to do so, We require certain User information such as
                  vehicle number, tag id, mobile number, company name etc.
                  (format shared below).{" "}
                </p>
                <p>
                  At a project, we classify the parking slots into following
                  categories :{" "}
                </p>
                <p>
                  <b>A. Based on vehicle type </b>
                </p>
                <p>1) 2 - Wheeler </p>
                <p>2) 4 - Wheeler </p>
                <p>
                  <b>B. Based on Slot Type </b>
                </p>
                <p>1) General - Allotted on first come first serve basis</p>
                <p>
                  2) Reserved - Allotted only to vehicles whitelisted as
                  reserved
                </p>
                <p>
                  As parking slots of the building are distributed among the
                  tenants, we need the tenant wise slot data immediately to
                  configure our systems accordingly. Therefore following data
                  needs to be shared by the building admin as soon as the
                  onboarding process starts in the given format.
                </p>
              </div>

              <div>
                <h5>
                  <b>
                    <p>1. Tenant Data Format</p>
                  </b>
                </h5>
                <table class="table table table-striped">
                  <tbody>
                    <tr>
                      <th>Company Name</th>
                      <th>LED Abbreviation</th>
                      <th>Tenant Admin Login Credentials</th>
                      <th>General Slots (4 Wheeler)</th>
                      <th>General Slots (2 Wheeler)</th>
                      <th>Reserve Slots (4 Wheeler)</th>
                      <th>Reserve Slots (2 Wheeler)</th>
                    </tr>
                    <tr>
                      <td>Samsung</td>
                      <td>SAMG</td>
                      <td>abc@samsung.com</td>
                      <td>20</td>
                      <td>10</td>
                      <td>1</td>
                      <td>4</td>
                    </tr>
                  </tbody>
                </table>
                <br></br>
                <p>
                  Corporate Admins need to send out communication to all the
                  tenant admins asking for the users to activate their tags.
                  Corporate Admins are also required to do follow ups to
                  expedite the process of User Onboarding. Following is the
                  suggested email schedule to be sent to tenants from corporate
                  admins.
                </p>
                <br></br>
                <table class="table table table-striped">
                  <tbody>
                    <tr>
                      <th>Event</th>
                      <th>Week</th>
                      <th>Timeline</th>
                      <th>Alignment</th>
                    </tr>
                    <tr>
                      <td>First reminder communications</td>
                      <td>Week 1</td>
                      <td>Immediately after onboarding</td>
                      <td>
                        <div className="col-sm-12">
                          <DropDownInput
                            data={[
                              { id: "Yes", name: "Yes" },
                              { id: "No", name: "No" },
                            ]}
                            label={localization.firstReminder}
                            required
                            value={
                              corporateAutofill?.first_reminder_communication
                            }
                            errorMsg={localization.requiredName}
                            getIdValue={(val) => {
                              handleInput2Value(
                                val.id,
                                "first_reminder_communication"
                              );
                            }}
                            isStarRequired={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Second reminder communications</td>
                      <td>Week 2</td>
                      <td>Immediately after onboarding</td>
                      <td>
                        <div className="col-sm-12">
                          <DropDownInput
                            data={[
                              { id: "Yes", name: "Yes" },
                              { id: "No", name: "No" },
                            ]}
                            label={localization.secondReminder}
                            required
                            value={corporateAutofill?.two_reminder_communication}
                            errorMsg={localization.requiredName}
                            getIdValue={(val) => {
                              handleInput2Value(
                                val.id,
                                "two_reminder_communication"
                              );
                            }}
                            isStarRequired={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Third reminder communications</td>
                      <td>Week 3</td>
                      <td>Immediately after onboarding</td>
                      <td>
                        <div className="col-sm-12">
                          <DropDownInput
                            data={[
                              { id: "Yes", name: "Yes" },
                              { id: "No", name: "No" },
                            ]}
                            label={localization.thirdReminder}
                            required
                            value={
                              corporateAutofill?.three_reminder_communication
                            }
                            errorMsg={localization.requiredName}
                            getIdValue={(val) => {
                              handleInput2Value(
                                val.id,
                                "three_reminder_communication"
                              );
                            }}
                            isStarRequired={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Fourth reminder communications</td>
                      <td>Week 4</td>
                      <td>Immediately after onboarding</td>
                      <td>
                        <div className="col-sm-12">
                          <DropDownInput
                            data={[
                              { id: "Yes", name: "Yes" },
                              { id: "No", name: "No" },
                            ]}
                            label={localization.fourthReminder}
                            required
                            value={
                              corporateAutofill?.four_reminder_communication
                            }
                            errorMsg={localization.requiredName}
                            getIdValue={(val) => {
                              handleInput2Value(
                                val.id,
                                "four_reminder_communication"
                              );
                            }}
                            isStarRequired={true}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <h5>
                  <b>
                    <p>User Onboarding Checklist (Yes/No)</p>
                  </b>
                </h5>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.tenantSlotsData}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.tenant_slots_data}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tenant_slots_data");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.tenantlogin}
                    required
                    value={corporateAutofill?.tenant_login}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tenant_login");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.qrPlacement}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.qr_placement}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "qr_placement");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.tenantAdmins}
                    required
                    value={corporateAutofill?.tenant_admins}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tenant_admins");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Entry Gate", name: "Entry Gate" },
                      { id: "Cafeteria", name: "Cafeteria" },
                      { id: "Common Area", name: "Common Area" },
                      { id: "Exit Gate", name: "Exit Gate" },
                      { id: "Reception", name: "Reception" },
                    ]}
                    label={localization.standeeDeployment}
                    required
                    value={corporateAutofill?.standee_deployment}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "standee_deployment");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div>
                <h5>
                  <b>Activites during the carnival</b>
                </h5>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.tagActivation}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.tag_activation}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tag_activation");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.parkPartner}
                    required
                    value={corporateAutofill?.park_partner}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "park_partner");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.park_partner === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.parkPartnerReason}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.park_partner_reason}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "park_partner_reason");
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.dailyCarCleaning}
                    required
                    value={corporateAutofill?.daily_car_cleaning}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "daily_car_cleaning");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.daily_car_cleaning === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.dailyCarCleaningReason}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.daily_car_cleaning_reason}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "daily_car_cleaning_reason");
                      }}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.carDisplay}
                    required
                    errorMsg={localization.requiredName}
                    value={corporateAutofill?.car_display}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "car_display");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.car_display === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.carDisplayReason}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.car_display_reason}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "car_display_reason");
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DatePicker
                    label={localization.carnivalDateTime}
                    required={false}
                    value={corporateAutofill?.carnival_date_time}
                    handleChange={(val) => {
                      handleInput2Value(val, "carnival_date_time");
                    }}
                  />
                </div>
              </div>
              <div>
                <h5>
                  <b>Prerequisites for the Carnival</b>
                </h5>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <TextAreaInput
                    type="text"
                    label={localization.identifiedAreaAndLocation}
                    rows={4}
                    onFocus={(val) => handleSaveDraft(val)}
                    value={formData[0]?.identified_area_location}
                    className={` inline-css scrollbar-styling`}
                    inputValue={formData[0]?.identified_area_location}
                    errorMsg={localization.isRequired}
                    handleChange={(val) => {
                      handleInput2Value(
                        val.target.value,
                        "identified_area_location"
                      );
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.flagInstallation}
                    required
                    value={corporateAutofill?.flag_installation}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "flag_installation");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.flag_installation === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.flagInstallationReason}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.flag_installation_reason}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "flag_installation_reason");
                      }}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.aligningBuildingAdmin}
                    value={corporateAutofill?.aligning_building}
                    required
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "aligning_building");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.aligning_building === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.aligningBuildingAdminReason}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={corporateAutofill?.aligning_building_reason}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "aligning_building_reason");
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.pushMessage}
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.push_message}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "push_message");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div>
                <h5>
                  <b>General T&C</b>
                </h5>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <p>
                    1. Carnival cancellation must be informed to the respective
                    Relationship Manager 72 hrs in advance.
                  </p>
                  <p>
                    2. Rs. 2500/- penalty will be charged if cancellation
                    happens at the last moment.
                  </p>
                </div>
              </div>

              <div>
                <br></br>
                <h5>
                  <b>Client Side POC Details</b>
                </h5>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.name}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.client_name}
                    isStarRequired={true}
                    handleChange={(value) => {
                      handleInput2Value(value, "client_name");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.designation}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.designation}
                    isStarRequired={true}
                    handleChange={(value) => {
                      handleInput2Value(value, "designation");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.emailAddress}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.email_address}
                    isStarRequired={true}
                    handleChange={(value) => {
                      handleInput2Value(value, "email_address");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.phoneNumber}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.phone_number}
                    isStarRequired={true}
                    handleChange={(value) => {
                      handleInput2Value(value, "phone_number");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div>
                    <br></br>
                    <h5>
                      <b>Any Other requirement - Please specify</b>
                    </h5>
                  </div>

                  <div className="col md-6">
                    <TextAreaInput
                      type="text"
                      label={localization.feedBack}
                      rows={4}
                      // value={formData[0]?.identified_area}
                      className={` inline-css scrollbar-styling`}
                      inputValue={formData[0]?.new_feedback}
                      value={formData[0]?.new_feedback}
                      onFocus={(val) => handleSaveDraft(val)}
                      errorMsg={localization.isRequired}
                      handleChange={(val) => {
                        handleInput2Value(val.target.value, "new_feedback");
                      }}
                    />
                  </div>
                </div>
              </div>
              <p>
                Any change other than flows and BOQ specified above will be
                considered separately and will have different commercials and
                timelines as per the revised scope of work.
              </p>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.rmName}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={corporateAutofill?.rm_name}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "rm_name");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.clientName}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.other_client_name}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "other_client_name");
                    }}
                  />
                </div>
              </div>
              <hr/>
              {/* new fields addition starts */}
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client will pay rentals on their own via self deposit flow"
                    }
                    required
                    value={corporateAutofill?.client_rental_self_deposit}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "client_rental_self_deposit");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client with payment rentals via online mode"
                    }
                    required
                    value={inputList[0]?.client_rental_online_mode}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "client_rental_online_mode");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client is aware on late payment fee clause if invoice due date is crossed"
                    }
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={corporateAutofill?.late_payment_fees_check}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "late_payment_fees_check");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client is aware that system auto shuts off if payment are pending for payment since defined time"
                    }
                    required
                    value={corporateAutofill?.auto_shuts_off_check}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "auto_shuts_off_check");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              {/* new fields addition ends */}
            </div>
          </div>
          <br />
          <br />
          <div className="btn-wrapper">
            <button disabled={false} type="submit" className="btn btn-primary">
              {localization.submit}
              <img src="../images/arrow-right.png" alt="" />
            </button>
            <br />
            <br />
          </div>
        </div>
      </form>
    </Layout>
  );
};

export default CorporateMallForm;
